import {useMemo} from "react";

import Checkbox from "@mui/material/Checkbox";

import Badge from "components/Badge";
import StyledTableCell from "components/Table/StyledTableCell";
import StyledTableRow from "components/Table/StyledTableRow";
import ImpactBadge from "components/ImpactBadge";
import PimStatusBadge from "components/PimStatusBadge";

import ProductCell from "./ProductCell";
import SuggestionCell from "./SuggestionCell";
import ActionButtons from "./ActionButtons";

import {getTranslation} from "../../../../../../../helpers/translations";

import {getFakeIASuggestionByField, getFieldToEnrich, getImpactByField} from "../helpers/product";

function TableRowItem({product, checked, onCheck}) {
    const fieldToEnrich = getFieldToEnrich(product);
    const randomLevel = useMemo(() => Math.floor(Math.random() * (3) + 1), [product.id]);

    return (
        <StyledTableRow>
            <StyledTableCell padding="checkbox" sx={{verticalAlign: "middle", padding: "16px 8px 16px 16px"}}>
                <Checkbox
                    size="small"
                    checked={checked}
                    onChange={onCheck}
                    sx={{color: "#d1d5db", "&.Mui-checked": {color: "#4338ca"}}}
                />
            </StyledTableCell>
            <StyledTableCell>
                <ProductCell
                    picture={product?.pictures?.[0]?.contentUrl}
                    name={getTranslation(product).name}
                    sku={product.sku}
                />
            </StyledTableCell>
            <StyledTableCell>
                <Badge rounded color={'error'}>{fieldToEnrich}</Badge>
            </StyledTableCell>
            <StyledTableCell>
                <ImpactBadge level={getImpactByField(fieldToEnrich)}/>
            </StyledTableCell>
            <StyledTableCell>
                <SuggestionCell text={getFakeIASuggestionByField(fieldToEnrich, randomLevel)} />
            </StyledTableCell>
            <StyledTableCell>
                <PimStatusBadge status={randomLevel}/>
            </StyledTableCell>
            <StyledTableCell/>
            <StyledTableCell>
                <ActionButtons
                    onAI={() => console.log("AI", product.sku)}
                    onEdit={() => console.log("Edit", product.sku)}
                    onValidate={() => console.log("Validate", product.sku)}
                    onDelete={() => console.log("Delete", product.sku)}
                />
            </StyledTableCell>
        </StyledTableRow>
    );
}

export default TableRowItem;
